import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Copy = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 12 12">
      <g id="百川" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="百川新导航样式1" transform="translate(-238.000000, -852.000000)">
          <g id="编组-17" transform="translate(238.000000, 852.000000)">
            <rect
              id="矩形"
              fillOpacity="0.4"
              fill="#52C41A"
              x="3"
              y="5"
              width="6"
              height="6"
              rx="1"
            ></rect>
            <g id="复制-(6)" fill="#041B0F" fillRule="nonzero">
              <path
                d="M10.6248532,9.71418889 L9.29008363,9.71418889 C8.9744738,9.71418889 8.71870348,9.4585638 8.71870348,9.14280873 C8.71870348,8.82705365 8.97461904,8.57142857 9.29008363,8.57142857 L10.6248532,8.57142857 C10.7529563,8.57142857 10.8569492,8.46714516 10.8569492,8.33933262 L10.8569492,1.37500151 C10.8569492,1.24718897 10.752811,1.14290556 10.6248532,1.14290556 L3.66066738,1.14290556 C3.53256436,1.14290556 3.42857143,1.24718897 3.42857143,1.37500151 L3.42857143,2.69466601 C3.42857143,3.01056632 3.17265586,3.26604616 2.85719127,3.26604616 C2.54172668,3.26604616 2.28581111,3.01042108 2.28581111,2.69466601 L2.28581111,1.37500151 C2.28581111,0.616695513 2.90265187,0 3.66081263,0 L10.6249985,0 C11.383014,0 12,0.616550272 12,1.37500151 L12,8.33918737 C11.9998548,9.09749337 11.3828688,9.71418889 10.6248532,9.71418889 L10.6248532,9.71418889 Z"
                id="路径"
              ></path>
              <path
                d="M8.33918737,11.9998548 L1.37500151,11.9998548 C0.616985996,11.9998548 0,11.3833045 0,10.6248532 L0,3.66066738 C0,2.90236139 0.616840755,2.28566587 1.37500151,2.28566587 L8.33918737,2.28566587 C9.09720289,2.28566587 9.71418889,2.90221614 9.71418889,3.66066738 L9.71418889,10.6248532 C9.71404365,11.3833045 9.09720289,11.9998548 8.33918737,11.9998548 Z M1.37500151,3.42857143 C1.24689849,3.42857143 1.14290556,3.53285484 1.14290556,3.66066738 L1.14290556,10.6248532 C1.14290556,10.7526658 1.24704373,10.8569492 1.37500151,10.8569492 L8.33918737,10.8569492 C8.4672904,10.8569492 8.57128333,10.7526658 8.57128333,10.6248532 L8.57128333,3.66066738 C8.57128333,3.53285484 8.46714516,3.42857143 8.33918737,3.42857143 L1.37500151,3.42857143 Z"
                id="形状"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  )
}
